<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <!-- <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-{{ itemsPerRow }} mb-2">
      @if (data?.product?.extra?.ar?.itemstatuscode != 10){
      <div class="card product-card"> -->
  @for (data of mappedData; track data?.product?.id; let last = $last) {
    @if (data?.product?.extra?.ar?.itemstatuscode !== 10) {
      <div class="col-6 col-md-4 col-lg-{{ itemsPerRow }} mb-2">
        <div class="card product-card">
          <div class="card-body">
            <div>
              <span class="favourite-icon-wrapper">
                <lib-favourite-product-icon [id]="data.product.id"></lib-favourite-product-icon>
              </span>
            </div>

            <div class="ribbons-container">
              <div class="ribbon" *ngIf="data.product.extra?.ar?.itemstatuscode === 8">
                <div
                  *ngIf="data.product.extra.ar.itemstatuscode == 8; else null" translate
                  class="ribbon-child ribbon-black"
                >
                  <div class="arrow-ribbon"></div>
                  TO_BE_PHASED_OUT
                </div>
              </div>

              <div class="ribbon" *ngIf="data.product.extra?.pim?.isNews == true">
                <div
                  *ngIf="data.product.extra.pim.isNews == true; else null" translate
                  class="ribbon-child ribbon-news"
                >
                  <div class="arrow-ribbon"></div>
                  NEWS_BANNER
                </div>
              </div>

              <div class="ribbon" *ngIf="data.product.extra?.pim?.isJosamNews == true">
                <div
                  *ngIf="data.product.extra.pim.isJosamNews == true; else null" translate
                  class="ribbon-child ribbon-news-josam"
                >
                  <div class="arrow-ribbon"></div>
                  NEWS_BANNER
                </div>
              </div>

              <div class="ribbon" *ngIf="data.product.extra?.pim?.isBlackhawkNews == true">
                <div
                  *ngIf="data.product.extra.pim.isBlackhawkNews == true" translate
                  class="ribbon-child ribbon-news-josam"
                >
                  <div class="arrow-ribbon"></div>
                  NEWS_BANNER
                </div>
              </div>

              <div class="ribbon" *ngIf="data.price.backendPrice?.levels?.[0]?.extra?.campaign">
                <div class="ribbon-child ribbon-campaign">
                  <div class="arrow-ribbon arrow-ribbon-campaign"></div>
                  <span translate>CAMPAIGN_UNTIL</span> {{ data.price.backendPrice.levels[0].extra.campaign.kampanjtomdat | date:'yyyy-MM-dd' }}
                </div>
              </div>
            </div>

            <div class="image-wrapper" (click)="goToDetail(data.product)">
              <img
                *ngIf="data.product.extra.images && data.product.extra.images[0] as image; else noimage"
                class="img-fluid"
                src="https://cdn1.gung.io/fit-in/250x250/filters:etag({{ image.s3ETag }})/{{
                  image.s3Uri
                }}"
                alt=""
              />
              <ng-template #noimage>
                <img
                  class="card-img-top img-fluid w-100"
                  src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
                  alt="NO IMAGE"
                  class="img-fluid mx-auto d-block"
                />
              </ng-template>
            </div>
            <div class="product-text pb-1">
              @if (data.product.extra?.ar?.ersatterartnr) {
                <div class="small text-muted text-right">({{'REPLACES_PRODUCT' | translate}} {{ data.product.extra?.ar?.ersatterartnr }}{{ replacementProductNames[data.product.extra.ar.ersatterartnr] ? ' - ' + replacementProductNames[data.product.extra.ar.ersatterartnr] : '' }})</div>
              }
              <div class="small font-weight-light">{{ data.product.id }}</div>
              <div class="small text-muted">{{ !isJosamProject ? data.product.extra?.ar?.q_popnr : data.product.extra?.ar?.artnrean }}</div>
              <div class="text-truncate">{{ data.product.name }}</div>
              @if(data.product?.extra?._addonPcs && isAddons) {
                <div class="text-truncate">
                  <span translate>RECOMMENDED_QTY</span> {{data.product?.extra?._addonPcs}} {{ data.product?.extra?.ar?.enhetskod || '' }}
                </div>
              }
              @if(data.product?.extra?._recommendedQty && !isAddons) {
                <div class="text-truncate">
                  <span translate>RECOMMENDED_QTY</span> {{data.product?.extra?._recommendedQty}} {{ data.product?.extra?.ar?.enhetskod || '' }}
                </div>
              }

              <!-- <div translate *ngIf="data.price" class="font-weight-bold">
                  {{ data.price.customerNetPrice.value | gungCurrency: data.price.customerNetPrice.currencyCode }}</div> -->
              @if (data.product.extra.ar?.itemstatuscode !== 98) {
              @if (data.price.backendPrice?.levels?.[0]?.extra?.campaign?.ordinaryPrl?.vb_pris) {
                <div>
                  <span class="original-price" [class.blur]="hidePrice">
                    {{ data.price.backendPrice.levels[0].extra.campaign.ordinaryPrl.vb_pris | number: '1.2-2' }} {{ data.price.customerGrossPrice.currencyCode }}
                  </span>
                </div>
              }
              <div>
                <span *ngIf="data.price.customerDiscountPercent !== 0 || shouldDisplayGrossPrice; else noDiscount"
                  >
                  <car-liner-price
                    [price]="data.price"
                    [display]="'code'"
                    type="GROSS"
                    [currency]="data.price.customerGrossPrice.currencyCode"
                    class="font-weight-bold"
                  ></car-liner-price
                  >&nbsp;
                    <span [class.blur]="hidePrice">
                      (-{{data.price.customerDiscountPercent}}% = {{ data.price.customerNetPrice.value | number: '1.2-2' }})
                    </span>
                  </span
                >
                <ng-template #noDiscount>
                  <car-liner-price
                    [price]="data.price"
                    [display]="'code'"
                    type="NET"
                    [currency]="data.price.customerNetPrice.currencyCode"
                    class="font-weight-bold"
                  ></car-liner-price>
                  @if (data.price.backendPrice?.levels?.[0]?.extra?.prl?.nettoejrabkod == '1') {
                    <span class="ml-2" translate>PRODUCT_WITHOUT_DISCOUNT</span>
                  }
                </ng-template>
              </div>
              }
              <div>
                <lib-availability [availability]="data.availability" [isSales]="isSales" *ngIf="includeAvailability">
                </lib-availability>
              </div>
            </div>

            <div class="d-flex">
              <div class="info-symbol-icon-wrapper" *ngIf="data.product.extra._hasInfoIcon">
                <i class="fa-regular fa-circle-exclamation"></i>
              </div>
              @if (data.product.extra.ar?.itemstatuscode !== 98) {
              <div class="buy-button-row flex-grow-1 align-self-center">
                <lib-buy-btn [id]="data.product.id" [product]="data.product"></lib-buy-btn>
              </div>
              } @else {
                <div class="buy-button-row flex-grow-1 align-self-center">
                  <span></span>
                </div>
              }

              @if (isJosamProject) {
                @if (data?.product?.extra?.ar?.itemtypecd6 == 1) {
                  <div class="included-items-icon-wrapper" *ngIf="data?.product?.extra?._hasIncludedIcon">
                    <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(data.product)"></i>
                  </div>
                }
              } @else {
                <div class="included-items-icon-wrapper" *ngIf="data?.product?.extra?._hasIncludedIcon">
                  <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(data.product)"></i>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  }
  <!-- </div> -->
  <!-- </div> -->
  <div *ngIf="findError" class="col-12 mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
